<app-breadcrumb></app-breadcrumb>

<div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
</div>

<div class="d-flex gap-4 align-items-top" style="float:right">
    <div class="backIconContiner" (click)="backToPreviousPage()" matTooltip="Go back">
        <i class="fa fa-arrow-left"></i>
    </div>
</div> <br><br>

<div class="position-relative grid-content" style="margin-top: 10px;">

    <mat-tab-group selectedIndex="0" mat-stretch-tabs class="activitytab mat-tab-container mat-elevation-z4"
        animationDuration="0ms" (selectedTabChange)="onTabChanged($event);" [(selectedIndex)]="selectedTabIndex">
        <mat-tab *ngFor="let tab of tabs" label='{{tab.tab_name}}'>
            <ng-template mat-tab-label>
                <span> <i class='{{tab.tab_icon}}' style="font-size: 18px;" aria-hidden="true"></i> </span>&nbsp;
                <span>{{tab.tab_name}}</span>
            </ng-template>
            <div class="no-data" *ngIf="!grid.length">
                <div class="row">There is no audit created yet </div><br>
            </div>
            <div *ngIf="grid.length">
                <div class="d-flex justify-content-between">
                    <div class="d-flex align-items-center px-3">
                        <div class="dropdown">
                        </div>
                    </div>
                    <div class="d-flex gap-3">
                        <div id="header-container">
                            <div class="">
                                <div class="search-container">
                                    <span class="fa fa-search form-control-feedback"></span>
                                    <input type="text" class="form-control search_input" style="font-size: 12px"
                                        placeholder="Search here..." [(ngModel)]="searchValue" />
                                </div>
                            </div>
                        </div>
                        <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
                            (click)="openReport('Excel')" style="cursor: pointer;">
                            <i class="fa fa-file-excel-o" style="font-size:18px;color:white"></i>
                            <span class="reload_text text-white">Excel Report</span>
                        </div>

                        <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
                            (click)="openReport('Pdf')" style="cursor: pointer;">
                            <i class="fa fa-file-pdf-o" style="font-size:18px;color:white"></i>
                            <span class="reload_text text-white">PDF Report</span>
                        </div>
                        <div class="reloadIconContiner d-flex gap-2 justify-content-center align-items-center"
                            (click)="refreshGridData()">
                            <img src="../../../assets/img/cr_module/reload.svg" width="18px" height="18px"
                                alt="reload" />
                            <span class="reload_text">Reload</span>
                        </div>
                    </div>
                </div>


                <div class="table-container">
                    <table class="vendors-table-container">
                        <th style="min-width: 60px; text-align: center;"
                            [class]="makeStickyColumns != -1 ? 'sticky-checkbox-col checkbox-col' : '' ">
                            <div style="display: flex;">
                                <div>
                                    <i id="parent-menu-icons" class="fa-solid fa-ellipsis-vertical"></i>
                                </div>
                            </div>
                        </th>
                        <th id="grid-header-container"
                            *ngFor="let oneQmsUsersDataForTable1Data of columnLists.fieldColumnarray; let ix = index;"
                            [ngStyle]="{'min-width': oneQmsUsersDataForTable1Data.width,'max-width': oneQmsUsersDataForTable1Data.width,'overflow': 'hidden',
              'text-overflow': 'ellipsis',
              'white-space': 'nowrap'}" class="sticky-dynamic-col1" (mouseover)="cssFunction(0)">
                            <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
                                <span>{{ oneQmsUsersDataForTable1Data.fieldColumnarray }}</span>
                                <div class="d-flex gap-2 align-items-center">
                                    <div
                                        (click)="sortColumn(columnLists.columnsListarray[ix],oneQmsUsersDataForTable1Data)">
                                        <img src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px"
                                            alt="sort" />
                                    </div>
                                    <!-- <div>
                                        <img src="../../../assets/img/qms_img/filter.svg" width="24px" height="24px"
                                            alt="filter" />
                                    </div> -->
                                </div>
                            </div>
                        </th>
                        <th id="menu" class="sticky-col first-col"></th>
                        <tr>
                            <td [class]="  makeStickyColumns != -1 ? 'sticky-checkbox-col checkbox-col' : '' "></td>
                            <td *ngFor=" let oneQmsUsersDataForTable1Data of columnLists.fieldColumnarray; let ix = index "
                                [ngStyle]="{ 'min-width': oneQmsUsersDataForTable1Data.width != null ? oneQmsUsersDataForTable1Data.width : '200px' }"
                                class="sticky-dynamic-col1" (mouseover)="cssFunction(0)">
                                <div class="row-search-container"><input type="text" class="form-control"
                                        placeholder="Search"
                                        (input)="applyFilter3(columnLists.columnsListarray[ix], $event)" /> </div>
                            </td>
                        </tr>
                        <tr *ngFor="let list of pagedItems  | searchFilter : searchValue; let idx = index;">
                            <td style="min-width: 60px; text-align: center;"
                                [class]="makeStickyColumns != -1 ? 'sticky-checkbox-col checkbox-col' : '' ">
                                <div style="display: flex;">
                                    <div [ngClass]="list.childCheckBox ?'static_icon':'hover-menu-icons'">
                                        <i class="fa-solid fa-ellipsis-vertical"></i>
                                    </div>
                                    <div>
                                        <input type="checkbox" style="zoom: 1.2;" [checked]="list.childCheckBox"
                                            (change)="dataGridChildCheckBoxChecked($event, list, idx)">
                                    </div>
                                </div>
                            </td>
                            <td id="grid-row-container"
                                *ngFor="let key of columnLists.columnsListarray1; let i = index;"
                                class="sticky-dynamic-row1" [ngStyle]="{'min-width': key.width[i],'max-width': key.width[i],'overflow': 'hidden',
                'text-overflow': 'ellipsis',
                'white-space': 'nowrap'}" (mouseover)="cssFunction(i)">
                                <span *ngIf="key.dataType=='CHECKBOX'">
                                    <div class="gridCheckBoxes">
                                        <img *ngIf="list[key.columnsListarray]" src="../../assets/img/accessSymbol.svg"
                                            alt="Yes" width="20" height="20">
                                        <img *ngIf="list[key.columnsListarray]==false"
                                            src="../../assets/img/noAcessSymbol.svg" alt="No" width="20" height="20">
                                    </div>
                                </span>
                                <span
                                    *ngIf="key.dataType!='CHECKBOX' && key.dataType!='DATE' && list[key.columnsListarray] !='htmlClobView'">{{
                                    list[key.columnsListarray]
                                    }}</span>
                                <span *ngIf="key.dataType=='DATE'">{{ list[key.columnsListarray] }}</span>
                                <span *ngIf="list[key.columnsListarray]=='htmlClobView'">
                                    <div class="download-button-continer btn-align" mat-dialog-actions>
                                        <button class="d-flex align-items-center" mat-stroked-button
                                            class="downloadButton" (click)="getClobData(list,key.columnsListarray)">
                                            <img src="../../../assets/img/cr_module/download.svg" width="12px"
                                                height="12px" alt="download">
                                            <span class="ms-1">View</span>
                                        </button>
                                    </div>
                                </span>
                            </td>
                        </tr>
                    </table>
                    <div class="d-flex justify-content-center">
                        <div class="width-cheat small paginationCell">
                            <div class="d-flex align-items-center gap-3">
                                <div class="pagination_text mt-3">
                                    {{ showingRowsText }}
                                    1-{{ perPage }} of {{ collectionSize | number }}
                                </div>
                                <div>
                                    <ngb-pagination class="leftpadding"
                                        (pageChange)="setPage(pager.currentPage, $event)" [disabled]="false"
                                        [collectionSize]="pager.totalItems" [(page)]="pager.currentPage"
                                        [maxSize]="maxSize" [rotate]="true" [pageSize]="perPage" [ellipses]="false"
                                        [boundaryLinks]="true" size="sm">
                                    </ngb-pagination>
                                </div>
                                <div ngbDropdown class="mt-3">
                                    <button class="btn btn-primary btn-sm mr-1 bg-white pagination_text"
                                        id="dropdownBasic1" ngbDropdownToggle>
                                        {{ perPage }}
                                        <i class="ms-1 fa-solid fa-chevron-down"></i>
                                    </button>
                                    <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
                                        <button ngbDropdownItem (click)="paginationCall(10)">10</button>
                                        <button ngbDropdownItem (click)="paginationCall(20)">20</button>
                                        <button ngbDropdownItem (click)="paginationCall(50)">50</button>
                                    </div>
                                    per page
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </mat-tab>
    </mat-tab-group>

</div>
<app-excel-pdf #excelPdfPopup [excelPdf]="excelPdf"></app-excel-pdf>